import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    breadcrumbContainer: {
        marginLeft: '20px',
    },
}));
